import { createApp } from 'vue';
import LottieToPngConverter from '@/Components/LottieToPngConverter.vue';
import '@styles/app.css';

createApp(LottieToPngConverter).mount('#lottie-to-png-converter');
